import React from 'react';
import { Eye, Layers, Zap } from 'lucide-react';

const WhatIsImmersid = () => {
  return (
    <section id="what-is" className="relative py-32 px-6 md:px-[7.6923%]" style={{
      background: 'linear-gradient(to bottom, #FFFFFF 0%, #FFF5E6 50%, #FFFFFF 100%)'
    }}>
      {/* Decorative blobs */}
      <div className="absolute top-10 left-10 w-64 h-64 bg-gradient-to-br from-blue-200/40 to-teal-200/40 blob-2 float-animation" style={{ animationDelay: '1s' }} />
      <div className="absolute bottom-20 right-20 w-72 h-72 bg-gradient-to-br from-yellow-200/40 to-orange-200/40 blob float-animation" style={{ animationDelay: '0.5s' }} />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-20">
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
            style={{
              background: 'linear-gradient(135deg, #FF8000 0%, #2E4080 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              letterSpacing: '-0.02em',
            }}
          >
            Make Your Dream Home a Reality
          </h2>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-[#4A4A4A] leading-relaxed">
            Stop wasting time and money on design mistakes. Visualize your ideas in AR, make confident decisions, and order everything directly from our platform — from design to furniture installation.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Feature 1 */}
          <div
            className="group glass p-8 rounded-3xl transition-all duration-400 hover:shadow-2xl hover:scale-105 border-2 border-orange-200 hover:border-orange-400"
            style={{ minHeight: '300px' }}
          >
            <div className="mb-6 inline-block p-4 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl">
              <Eye size={32} color="white" strokeWidth={2} />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-[#1A1A1A]">
              See Before You Build
            </h3>
            <p className="text-base text-[#4A4A4A] leading-relaxed">
              Walk through your future home using AR on your phone. Visualize every detail before spending a single dollar. No more costly design mistakes or regrets.
            </p>
          </div>

          {/* Feature 2 */}
          <div
            className="group glass p-8 rounded-3xl transition-all duration-400 hover:shadow-2xl hover:scale-105 border-2 border-blue-200 hover:border-blue-400"
            style={{ minHeight: '300px' }}
          >
            <div className="mb-6 inline-block p-4 bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl">
              <Layers size={32} color="white" strokeWidth={2} />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-[#1A1A1A]">
              Direct Platform Control
            </h3>
            <p className="text-base text-[#4A4A4A] leading-relaxed">
              Skip unscrupulous contractors. Order furniture, materials, and installation services directly through our platform with transparent pricing and trusted partners.
            </p>
          </div>

          {/* Feature 3 */}
          <div
            className="group glass p-8 rounded-3xl transition-all duration-400 hover:shadow-2xl hover:scale-105 border-2 border-yellow-200 hover:border-yellow-400"
            style={{ minHeight: '300px' }}
          >
            <div className="mb-6 inline-block p-4 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-2xl">
              <Zap size={32} color="white" strokeWidth={2} />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-[#1A1A1A]">
              AI Design Assistant
            </h3>
            <p className="text-base text-[#4A4A4A] leading-relaxed">
              Get instant design suggestions, accurate cost estimates, and shopping lists. Our AI helps you make smart decisions without needing expensive designers.
            </p>
          </div>
        </div>

        {/* Image showcase */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="relative overflow-hidden rounded-3xl group shadow-xl">
            <img
              src="https://images.pexels.com/photos/34987117/pexels-photo-34987117.jpeg"
              alt="AR Experience"
              className="w-full h-[400px] object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="glass rounded-2xl p-4 border border-white/30">
                <p className="text-xl font-bold text-white">
                  Visualize on Your Phone with AR
                </p>
              </div>
            </div>
          </div>
          <div className="relative overflow-hidden rounded-3xl group shadow-xl">
            <img
              src="https://images.pexels.com/photos/18435276/pexels-photo-18435276.jpeg"
              alt="Modern Interior"
              className="w-full h-[400px] object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="glass rounded-2xl p-4 border border-white/30">
                <p className="text-xl font-bold text-white">
                  Order Directly Through Platform
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsImmersid;
